import { CatalogCategory } from "../types/catalogCategory";

export interface CategorizableCatalogItem {
  category_id: number | null;
  category?: CatalogCategory | null;
}

/** @deprecated Use CategorizableCatalogItem */
export type CategorizableService = CategorizableCatalogItem;

export interface CatalogCategoryGroup<T extends CategorizableCatalogItem> {
  groupKey: string;
  label: string;
  sortOrder: number;
  services: T[];
}

/** @deprecated Use CatalogCategoryGroup */
export type ServiceCategoryGroup<T extends CategorizableCatalogItem> = CatalogCategoryGroup<T>;

export const SUGGESTED_CATALOG_CATEGORY_KEYS = [
  "hair",
  "nails",
  "aesthetics",
] as const;

export type SuggestedCatalogCategoryKey = (typeof SUGGESTED_CATALOG_CATEGORY_KEYS)[number];

export const suggestedCatalogCategorySortOrder: Record<SuggestedCatalogCategoryKey, number> = {
  hair: 0,
  nails: 1,
  aesthetics: 2,
};

export function groupCatalogItemsByCategory<T extends CategorizableCatalogItem>(
  items: T[],
  categories: CatalogCategory[],
  generalLabel: string
): CatalogCategoryGroup<T>[] {
  const groups: CatalogCategoryGroup<T>[] = [];
  const sortedCategories = [...categories].sort((left, right) => left.sort_order - right.sort_order);

  sortedCategories.forEach((category) => {
    const matched = items.filter((item) => item.category_id === category.id);

    if (matched.length > 0) {
      groups.push({
        groupKey: `category-${category.id}`,
        label: category.name,
        sortOrder: category.sort_order,
        services: matched,
      });
    }
  });

  const uncategorized = items.filter((item) => item.category_id == null);

  if (uncategorized.length > 0) {
    groups.push({
      groupKey: "general",
      label: generalLabel,
      sortOrder: Number.MAX_SAFE_INTEGER,
      services: uncategorized,
    });
  }

  return groups;
}

/** @deprecated Use groupCatalogItemsByCategory */
export function groupServicesByCategory<T extends CategorizableCatalogItem>(
  services: T[],
  categories: CatalogCategory[],
  generalLabel: string
): CatalogCategoryGroup<T>[] {
  return groupCatalogItemsByCategory(services, categories, generalLabel);
}
